import { Action } from '@ngrx/store';
import { CountryLeaderboard, CountryLeaderboardsData, LeaderboardUserModel } from '../../models';

export const GET_LEADERBOARD = '[Leaderboard] Get';
export const GET_LEADERBOARD_SUCCESS = '[Leaderboard] Get Success';
export const GET_LEADERBOARD_FAILURE = '[Leaderboard] Get Failure';
export const GET_COUNTRY_LEADERBOARDS = '[Country Leaderboards] Get';
export const GET_COUNTRY_LEADERBOARDS_SUCCESS = '[Country Leaderboards] Get Success';
export const GET_COUNTRY_LEADERBOARDS_FAILURE = '[Country Leaderboards] Get Failure';
export const UPDATE_COUNTRY_LEADERBOARD = '[Country Leaderboards] Update'

export class GetLeaderboard implements Action {
    readonly type = GET_LEADERBOARD;
}
export class GetLeaderboardSuccess implements Action {
    readonly type = GET_LEADERBOARD_SUCCESS;
    constructor(public users: LeaderboardUserModel[]) { }
}
export class GetLeaderboardFailure implements Action {
    readonly type = GET_LEADERBOARD_FAILURE;
    constructor(public error: any) { }
}

export class GetCountryLeaderboards implements Action {
  readonly type = GET_COUNTRY_LEADERBOARDS;
}

export class GetCountryLeaderboardsSuccess implements Action {
  readonly type = GET_COUNTRY_LEADERBOARDS_SUCCESS;
  constructor(public leaderboards: CountryLeaderboardsData, public leaderboard: CountryLeaderboard) { }
}

export class GetCountryLeaderboardsFailure implements Action {
  readonly type = GET_COUNTRY_LEADERBOARDS_FAILURE;
  constructor(public error: any) { }
}

export class UpdateCountryLeaderboard implements Action {
  readonly type = UPDATE_COUNTRY_LEADERBOARD;
  constructor(public leaderboard: CountryLeaderboard) { }
}

export type All = GetLeaderboard | GetLeaderboardSuccess | GetLeaderboardFailure | GetCountryLeaderboards | GetCountryLeaderboardsFailure | GetCountryLeaderboardsSuccess | UpdateCountryLeaderboard;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/actions/leaderboard.actions.ts